<template>
  <div class="row">
    <load v-if="loading" message="Carregando as Atividades do Acolhimento" />
    <div v-else class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <div class="card mb-0 shadow">
            <div class="card-body">
              <div class="tab-content">
                <div v-if="telaAtual === 'lista'" class="animate__animated animate__fadeIn">
                  <div class="row">
                    <div class="col">
                      <div class="row col-12 pb-3 px-0 m-0 d-flex justify-content-between">
                        <h4 class="font-weight-bold">Atividades</h4>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="d-flex align-items-center justify-content-between mb-4">
                        <div>
                          <button class="btn btn-primary" @click="telaAtual='nova'">
                            <i class="fas fa-plus-square" />
                            {{ $t("Incluir nova atividade") }}
                          </button>
                        </div>
                        <div>
                          <div>
                            <b-button-group>
                              <b-button
                                variant="outline-dark"
                                :class="
                                  viewFilterReport === true ? 'active' : ''
                                "
                                @click="viewFilters"
                              >
                                <i class="fas fa-filter"></i>
                                {{ $t("Filtros") }}
                              </b-button>
                              <b-button variant="outline-dark" @click="print()">
                                <i class="fas fa-print"></i>
                              </b-button>
                              <!-- <b-button
                                variant="outline-dark"
                                @click="exportar()"
                                :title="$t('Exportar')"
                                v-b-tooltip.hover
                              >
                                <i class="fas fa-file-excel"></i>
                              </b-button> -->
                            </b-button-group>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12" v-if="viewFilterReport">
                      <form
                        @submit.prevent="getAtividades"
                        ref="formFiltros"
                      >
                        <div class="row">
                          <form-calendar
                            v-model="data_inicio"
                            grid="4"
                            label="Data Inicial"
                          />

                          <form-calendar
                            v-model="data_fim"
                            grid="4"
                            label="Data Final"
                            :required="verificaDataInicial"
                          />

                          <form-select
                            v-model="filtroStatus"
                            label="Status"
                            :itens="statusOptions"
                            grid="4"
                          />
                        </div>
                        <div
                          class="row pt-2 mb-4 px-0 d-flex justify-content-end"
                        >
                          <div class="col-auto px-2 text-right">
                            <button
                              class="btn btn-default btn-sm"
                              @click.prevent="
                                limparFiltros();
                                viewFilterReport = false;
                              "
                            >
                              <i class="fas fa-times"></i>
                            </button>

                            <button
                              type="button"
                              class="btn btn-secondary btn-sm"
                              @click.prevent="limparFiltros()"
                            >
                              {{ $t("Limpar Filtros") }}
                            </button>
                            <button
                              class="btn btn-success btn-submit btn-sm"
                              data-style="zoom-in"
                              type="submit"
                            >
                              <i class="fas fa-chart-bar"></i>
                              {{ $t("Filtrar") }}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                    <load mode="table" v-if="loadingAtividades" />
                    <div class="col-12" v-else>
                      <print-content>
                        <b-table
                          :fields="[
                            { key: 'protocolo', label: $t('Detalhes') },
                            { key: 'data_atividade', label: $t('Data e Hora') },
                            { key: 'status', label: $t('Status') },
                            { key: 'actions', label: '', class: 'text-right no-print' }
                          ]"
                          :items="AtividadesList"
                          :responsive="true"
                          striped
                          hover
                          show-empty
                          small
                          outlined
                          stacked="xs"
                          table-class="mb-3"
                        >
                          <template v-slot:cell(protocolo)="data">
                            Protocolo:
                            <b>{{ data.item.protocolo }}</b>
                            <br /> 
                            Atividade: <b>{{ data.item.atividade }}</b> 
                            <br />
                            Frequência:
                            <b> {{ data.item.frequencia }}</b>
                            <br />
                            Objetivo:
                            <b>{{ data.item.objetivo }}</b>
                            <br>
                            Local da Atividade:
                            <b>{{ data.item.local }}</b>
                          </template>
                          <template v-slot:cell(data_atividade)="data">
                            {{ formatarDataHora(data.item.data_atividade, data.item.hora_atividade) }}
                          </template>
                          <template v-slot:cell(status)="data">
                            <span :class="statusClasse(data.item.status)">
                              {{ data.item.status }}
                            </span>
                          </template>
                          <template v-slot:cell()="data">
                            <button @click="abrirEdicao(data.item)" class="px-2 mb-0 btn btn-sm btn-success">
                              <i class="mdi mdi-square-edit-outline" />
                            </button>

                            <b-button
                              :title="$t('Visualizar e Imprimir Atividade')"
                              @click="imprimirAtividade(data.item.id)"
                              class="px-2 mb-0"
                              size="sm"
                              type="button"
                              v-b-tooltip.hover
                              variant="primary"
                            >
                              <i class="mdi mdi-eye" />
                            </b-button>
                          </template>
                          <template v-slot:empty="scope">
                            <div class="text-center my-5">
                              <img
                                :alt="$t('No results')"
                                class="mb-5"
                                src="/img/icons/robot.svg"
                                style="max-height: 165px"
                              />
                              <h3 class="bold">
                                {{ $t("No records found") }}
                              </h3>
                            </div>
                          </template>
                        </b-table>
                      </print-content>
                      <div class="row align-items-center">
                        <div class="col-lg-6 col-md-12">
                          <div class="form-group d-inline-flex mb-0">
                            <select
                              class="form-control"
                              style="width: 70px"
                              v-model="perPage"
                              v-on:change="getAtividades"
                            >
                              <option value="5">5</option>
                              <option value="10">10</option>
                              <option value="25">25</option>
                              <option value="50">50</option>
                            </select>
                          </div>
                          <div class="d-inline-flex ml-2">
                            <b-pagination
                              :per-page="perPage"
                              :total-rows="pagination.total"
                              @change="changePage"
                              v-model="page"
                            />
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                          <div class="float-lg-right">
                            {{ $t("Showing page") }}
                            {{ pagination.currentPage }}
                            de
                            {{ pagination.totalPages }}
                            {{ $t("pages in") }}
                            {{ pagination.total }}
                            {{ $t("records") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <NovaAtividade v-if="telaAtual === 'nova'" :item="item" @voltar="telaAtual='lista'" @atividadeCriada="abrirEdicao"/>
                <EditAtividade v-else-if="telaAtual === 'editar'" :atividade="itemSelecionado" :item="item" @voltar="telaAtual='lista'" @atualizado="carregarDados"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NovaAtividade from "./Atividade";
import EditAtividade from "./EditAtividade.vue";
import moment from 'moment'

export default {
  props: {
    item: {
      type: Object,
      required: true,
    }
  },
  components: { NovaAtividade, EditAtividade },
  name: "Atividades",
  metaInfo() {
    return {
      title: this.$i18n.t("Atividades"),
    };
  },
  data() {
    return {
      page: 1,
      perPage: 10,
      loadingAtividades: false,
      itemSelecionado: null,
      filtroStatus: null,
      filtroFamiliar: null,
      data_inicio: null,
      data_fim: null,
      status: [],
      familiares: [],
      AtividadesList: [],
      pagination: {},
      showName: false,
      user_id: this.$store.state.user.id,
      unidade_id: this.$store.state.user.unidade_id,
      nova_atividade: false,
      search: "",
      isLoadingMsg: false,
      loading: false,
      statusOptions: [
        { id: '', value: 'Todos' },
        { id: 'Aberto', value: 'Aberto' },
        { id: 'Em andamento', value: 'Em andamento' },
        { id: 'Cancelado', value: 'Cancelado' },
        { id: 'Realizado', value: 'Realizado' },
        { id: 'Finalizado', value: 'Finalizado' },
        { id: 'Inativo', value: 'Inativo' }
      ],
      telaAtual: 'lista',
    };
  },
  mounted() {
    this.getAtividades();
  },
  watch: {
    item: {
      immediate: true,
      handler() {
        this.page = 1;
        this.getAtividades();
      },
    },
  },
  methods: {
    abrirEdicao(atividade) {
      this.telaAtual = 'editar';
      this.itemSelecionado = atividade;
    },
    statusClasse(status) {
      switch (status) {
        case 'Aberto':
          return 'badge bg-info text-white';
        case 'Em andamento':
          return 'badge bg-primary text-white';
        case 'Cancelado':
          return 'badge bg-danger text-white';
        case 'Realizado':
          return 'badge bg-success text-white';
        case 'Finalizado':
          return 'badge bg-dark text-white';
        case 'Inativo':
          return 'badge bg-secondary text-white';
        default:
          return 'badge bg-light text-dark';
      }
    },
    formatarDataHora(data, hora) {
      if (!data) return '';
      let dataFormatada = moment(data).format('DD/MM/YYYY');
      let horaFormatada = hora ? moment(hora, 'HH:mm:ss').format('HH:mm') : '';
      return hora ? `${dataFormatada} ${horaFormatada}` : dataFormatada;
    },
    getAtividades() {
      this.loadingAtividades = true;

      const filtroDatas = [];
      if (this.data_inicio) filtroDatas.push(this.$options.filters.formatDateYMD(this.data_inicio));
      if (this.data_fim) filtroDatas.push(this.$options.filters.formatDateYMD(this.data_fim));

      axios.get("api/dashboard/acolhimento/idoso/atividades/buscar", {
        params: {
          acolhimento_id: this.item.id,
          page: this.page,
          perPage: this.perPage,
          filtroStatus: this.filtroStatus,
          filtroDatas,
          search: this.search,
        },
      })
      .then(response => {
        this.AtividadesList = response.data.data.data;
        this.pagination = response.data.pagination;

        if (this.pagination.totalPages && this.pagination.totalPages < this.page) {
          this.page = this.pagination.totalPages;
          this.getAtividades();
        }
      })
      .catch(() => {})
      .finally(() => {
        this.loadingAtividades = false;
      });
    },

    exportar() {
      this.isLoadingMsg = true;
      this.loading = true;

      const filtroDatas = [];
      if (this.data_inicio) filtroDatas.push(this.$options.filters.formatDateYMD(this.data_inicio));
      if (this.data_fim) filtroDatas.push(this.$options.filters.formatDateYMD(this.data_fim));

      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo da quantidade de registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });

      axios.get("api/dashboard/acolhimento/idoso/atividades/buscar", {
        params: {
          acolhimento_id: this.item.id,
          filtroStatus: this.filtroStatus,
          filtroDatas,
          export: "ok",
        },
      })
      .then((response) => {
        this.isLoadingMsg = false;
        this.loading = false;

        swal.fire({
          title: "Arquivo Pronto para Download!",
          html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
          icon: "success",
          showConfirmButton: false,
        });
      })
      .finally(() => {
        this.isLoadingMsg = false;
        this.loading = false;
      });
    },

    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getAtividades();
      }
    },

    imprimirAtividade(id) {
      this.$router.push({
        path: `/dashboard/acolhimento/idoso/atividades/${id}`
      });
    },

    limparFiltros() {
      this.search = "";
      this.filtroStatus = null;
      this.data_inicio = null;
      this.data_fim = null;
      this.filtroFamiliar = null;
      this.page = 1;
      this.getAtividades();
    },
  },
};
</script>